import { literal } from 'superstruct';
import { fireCustomEvent } from './modules/fire-custom-document-event';
export const cartDrawerOpenRequestEventType = 'theme:cart_drawer_open_request';
export const CartDrawerOpenRequestEventType = literal(cartDrawerOpenRequestEventType);
export const sendCartDrawerOpenRequestEvent = function() {
    fireCustomEvent(cartDrawerOpenRequestEventType, null);
};
